import React from "react";
import { PLAYS } from "../../../constants/activationConsoleData";

export default function ActivationPlaybookTab({ onOpenPlay }) {
  return (
    <>
      <div className="ac-inline-note" style={{ marginBottom: 24 }}>
        <strong>5 moves that actually compound.</strong> Tier 1 = do now. Tier 2 = do this week. Tier 3 =
        do once Tier 1 is running.
      </div>
      <div className="ac-playbook-grid">
        {PLAYS.map((p) => (
          <button
            key={p.id}
            type="button"
            className={`ac-play-card tier-${p.tier}`}
            onClick={() => onOpenPlay(p)}
          >
            <div className="ac-pc-head">
              <div className="ac-pc-top">
                <div className="ac-pc-num ac-serif">{p.num}</div>
                <span className={`ac-pc-tier tier-pill-${p.tier}`}>
                  Tier {p.tier}
                  {p.tier === 1 ? " — Do Now" : p.tier === 2 ? " — This Week" : " — Phase 2"}
                </span>
              </div>
              <div className="ac-pc-title">{p.title}</div>
              <div className="ac-pc-where">📍 {p.where}</div>
            </div>
            <div className="ac-pc-body">
              <div className="ac-pc-section">
                <div className="ac-pc-section-lbl">Why it works</div>
                <div className="ac-pc-section-text">{p.why}</div>
              </div>
              <div className="ac-pc-section">
                <div className="ac-pc-section-lbl">Success signal</div>
                <div className="ac-pc-signal">{p.signal}</div>
              </div>
            </div>
            <div className="ac-pc-footer">
              <span style={{ fontSize: 10, color: "var(--muted)" }}>{p.phase || ""}</span>
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
